<!--
    描述：项目发票
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
    <template v-else>
      <div>
        当前项目投标人开票
        <span style="color: #0000FF">{{ tableData.length }}</span
        >张
      </div>
      <div class="mt10">
        <el-table
          :data="tableData"
          highlight-current-row
          row-key="id"
          border
          ref="table"
          style="width: 100%"
        >
          <el-table-column
            prop="submissionDate"
            show-overflow-tooltip
            label="提交日期"
            align="center"
            width="151"
          ></el-table-column>
          <el-table-column
            label="企业名称"
            show-overflow-tooltip
            prop="companyName"
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            label="税号"
            prop="taxCode"
            show-overflow-tooltip
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            label="开户行"
            prop="openingBank"
            align="center"
            show-overflow-tooltip
            width="111"
          ></el-table-column>
          <el-table-column
            prop="branchBank"
            label="开户行支行"
            show-overflow-tooltip
            min-width="130"
          >
          </el-table-column>
          <el-table-column
            label="银行账号"
            prop="bankAccount"
            align="center"
            show-overflow-tooltip
            min-width="121"
          >
          </el-table-column>
          <el-table-column
            label="支付行号"
            align="center"
            prop="barnchBankAccount"
            show-overflow-tooltip
            min-width="121"
          >
          </el-table-column>
          <el-table-column
            prop="totalMoney"
            label="开票金额"
            align="center"
            show-overflow-tooltip
            min-width="121"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.totalMoney }}元 </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="invoiceType"
            label="状态"
            align="center"
            show-overflow-tooltip
            min-width="111"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.invoiceState == 1"
                >已开票{{
                  scope.row.invoiceType == 1 ? "（纸质）" : "（电子）"
                }}
              </span>
              <span v-if="scope.row.invoiceState == 2">待开票</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.invoiceState == 1"
                size="mini"
                @click="viewBill(scope.row)"
                >查看发票
              </el-button>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="w-table-footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageList"
          :page-size="pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </template>
    <!--弹窗-->
    <el-dialog
      :visible.sync="auditShow"
      width="50%"
      center
      title="查看发票（纸质/电子）"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <div class="dialog-box">
        <img
          v-for="item in billList"
          :src="imgUrl + item.fullFilePath"
          :key="item.id"
          style="width: 100%"
        />
      </div>
      <div style="text-align: center">
        <el-button
          class="btn btn-blue"
          type="primary"
          size="small"
          @click="downloadAll"
          >发票下载
        </el-button>
        <el-button class="btn cancel-btn" size="small" @click="closeDialog"
          >关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryApplicationInvoiceList,
  queryInvoice
} from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";

export default {
  name: "pro-bill",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    imgUrl() {
      let uploadUrl = "";
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }
      return uploadUrl;
    }
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      tableData: [],
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      billList: [], // 发票
      currentRowData: {} // 当前行数据
    };
  },
  methods: {
    // 获取列表数据
    queryApplicationInvoiceList() {
      queryApplicationInvoiceList({
        subProjectId: this.rowData.businessId,
        current: this.currentPage,
        size: this.pageSize
      }).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },

    // 查看进度
    viewBill(currentData) {
      this.currentRowData = currentData;
      queryInvoice({
        id: currentData.id,
        invoiceType: currentData.invoiceType
      }).then(res => {
        if (res.operationCode == 1) {
          this.auditShow = true;
          this.billList = res.data;
        }
      });
    },
    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryApplicationInvoiceList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryApplicationInvoiceList();
    },

    // 批量下载
    downloadAll() {
      this.billList.map(item => {
        const url = process.env.VUE_APP_UPLOAD_URL + item.fullFilePath;
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 防止影响页面
        iframe.style.height = 0; // 防止影响页面
        iframe.src = url;
        document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
        // 2分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
        setTimeout(() => {
          iframe.remove();
        }, 2 * 60 * 1000);
        // window.open(process.env.VUE_APP_UPLOAD_URL + item.fullFilePath, '_self', true)
      });
    },

    // close 审查弹框
    closeDialog() {
      this.auditShow = false;
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped>
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}

.el-button {
  background-color: #199ed8;
  color: white;
}
</style>
